// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-tabs-wrapper {
  background: #fff;
  border-radius: 3px;
  flex-direction: column;
  display: flex;
  box-shadow: 0 1px 1px #0000001a;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/NavTabs/NavTabsWrapper.css","webpack://./services/frontend/app/components/NavTabs/NavTabsWrapper.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,+BAA+B;AACjC","sourcesContent":[".nav-tabs-wrapper {\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n}\n",".nav-tabs-wrapper {\n  background: #fff;\n  border-radius: 3px;\n  flex-direction: column;\n  display: flex;\n  box-shadow: 0 1px 1px #0000001a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
